import { Injectable, isDevMode, OnDestroy } from '@angular/core';
import { filter, Subscription } from 'rxjs';
import { ApplicationInsights, IPageViewTelemetry, IEventTelemetry,
         IExceptionTelemetry, LoggingSeverity } from '@microsoft/applicationinsights-web';
import { environment } from '../../environments/environment';
import { ActivatedRouteSnapshot, ResolveEnd, Router } from '@angular/router';
import { StarbaseLoginService } from 'starbase-login';

@Injectable({
  providedIn: 'root'
})
export class AppInsightsService implements OnDestroy {
  private routerSubscription: Subscription;
  private appInsights = new ApplicationInsights({
    config: {
      instrumentationKey: environment.appInsights.instrumentationKey,
      appId: 'ngScaleTech-West',
      loggingLevelConsole: LoggingSeverity.CRITICAL,
      enableAutoRouteTracking: true,
      disablePageUnloadEvents: ['unload']
    }
  });
  private appVersion: string;

  constructor(private router: Router, private loginSvc: StarbaseLoginService) {
    this.appVersion = environment.VERSION + ' - ' + environment.packageDate + (environment.testMode ? ' (test mode)'  : '');
    this.appInsights.loadAppInsights();
    this.routerSubscription = this.router.events.pipe(filter(event => event instanceof ResolveEnd)).subscribe((event: ResolveEnd) => {
      const activatedComp = this.getActivatedComponent(event.state.root);
      if (activatedComp) {
        this.logPageView(`${activatedComp.name} ${this.getRouteTemplate(event.state.root)}`, event.urlAfterRedirects);
      }
    });
  }
  ngOnDestroy() {
    this.routerSubscription.unsubscribe();
  }

  private getActivatedComponent(snapshot: ActivatedRouteSnapshot): any {
    if (snapshot.firstChild) {
      return this.getActivatedComponent(snapshot.firstChild);
    }
    return snapshot.component;
  }
  private getRouteTemplate(snapshot: ActivatedRouteSnapshot): string {
    let path = '';
    if (snapshot.routeConfig) {
      path += snapshot.routeConfig.path;
    }
    if (snapshot.firstChild) {
      return path + this.getRouteTemplate(snapshot.firstChild);
    }
    return path;
  }
  private AddGlobalProperties(properties?: { [key: string]: string }): { [key: string]: string } {
    if (!properties) {
        properties = {};
    }
    properties['appVersion'] = this.appVersion;
    try {
      properties['username'] = this.loginSvc.getUsername();
    } catch {
      properties['username'] = 'Error';
    }

    return properties;
  }

  public logPageView(name?: string, uri?: string, properties?: { [key: string]: string }, measurements?: { [key: string]: number }) {
    if (isDevMode()) { return; }
    const telem: IPageViewTelemetry = {
      name : name,
      uri : uri,
      properties : this.AddGlobalProperties(properties),
      measurements : measurements
    };
    this.appInsights.trackPageView(telem);
  }
  public logEvent(name: string, properties?: { [key: string]: string }, measurements?: { [key: string]: number }) {
    if (isDevMode()) { return; }
    const telem: IEventTelemetry = {
      measurements : measurements,
      name : name,
      properties : this.AddGlobalProperties(properties)
    };
    this.appInsights.trackEvent(telem);
  }
  public logError(error: Error, properties?: { [key: string]: string }, measurements?: { [key: string]: number }) {
    if (isDevMode()) { return; }
    const telem: IExceptionTelemetry = {
      properties: this.AddGlobalProperties(properties),
      measurements: measurements,
      exception: error
    };
    this.appInsights.trackException(telem);
  }

}
